import styled from 'styled-components';
import { appTheme } from '../../../../theme';

export const Container = styled.div`
    width: 100%;
`;

export const Title = styled.p`
    margin-top: 20px;
    font-size: 16px;
    font-weight: bold;
    color: ${appTheme.title};
    margin-bottom: 10px;
    text-transform: uppercase;
`;

export const Description = styled.p`
    font-size: 12px;
    color: ${appTheme.title};
    margin-bottom: 10px;
`;

export const Content = styled.div`
    width: 100%;
    flex-direction: column;
    margin-top: 10px;
    margin-bottom: 10px;
`;

export const Input = styled.input`
    width: 100%;
    height: 40px;
    padding: 10px;
    background-color: ${appTheme.cardB3};
    border-radius: 5px;
    color: ${appTheme.gray};
    border: unset;
`;
